// components/ProjectFilters.js
export default class ProjectFilters {
    static init() {
        if (document.getElementById('projets')) {
            new ProjectFilters();
        }
    }

    constructor() {
        this.projectsContainer = document.getElementById('projets');
        this.activeFilters = {
            audience: null,
            thematic: null
        };
        this.setupEventListeners();
        this.initializeActiveFilters();
    }

    initializeActiveFilters() {
        // Récupérer les filtres actifs au chargement
        const audienceButton = document.querySelector('.btn-project-audience.active');
        const thematicButton = document.querySelector('.btn-project-thematic.active');

        if (audienceButton) {
            this.activeFilters.audience = audienceButton.getAttribute('data-term');
        }
        if (thematicButton) {
            this.activeFilters.thematic = thematicButton.getAttribute('data-term');
        }
    }

    setupEventListeners() {
        document.querySelectorAll('.btn-project-audience, .btn-project-thematic').forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const button = e.target.closest('a');
                if (!button) return;

                const filterType = button.classList.contains('btn-project-audience') ? 'audience' : 'thematic';
                const termSlug = button.getAttribute('data-term');

                // Toggle du filtre
                if (button.classList.contains('active')) {
                    this.activeFilters[filterType] = null;
                    button.classList.remove('active');
                } else {
                    // Désactiver les autres boutons du même type
                    document.querySelectorAll(`.btn-project-${filterType}.active`).forEach(btn => {
                        btn.classList.remove('active');
                    });
                    this.activeFilters[filterType] = termSlug;
                    button.classList.add('active');
                }

                // Construire l'URL avec les filtres actifs
                const url = this.buildFilterUrl();

                // Mettre à jour l'URL et charger les projets
                history.pushState({}, '', url);
                this.loadProjects(url);
            });
        });

        window.addEventListener('popstate', () => {
            this.loadProjects(window.location.pathname + window.location.search);
        });
    }

    buildFilterUrl() {
        const url = new URL('/projets/', window.location.origin);

        if (this.activeFilters.audience) {
            url.searchParams.append('project_audience', this.activeFilters.audience);
        }
        if (this.activeFilters.thematic) {
            url.searchParams.append('project_thematic', this.activeFilters.thematic);
        }

        return url.pathname + url.search;
    }

    async loadProjects(url) {
        try {
            const ajaxUrl = new URL(url, window.location.origin);
            ajaxUrl.searchParams.append('ajax', '1');

            const response = await fetch(ajaxUrl.toString(), {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.html) {
                this.projectsContainer.innerHTML = data.html;
            }

        } catch (error) {
            console.error('Error loading projects:', error);
        }
    }


}